import React from "react";
import { Spacer } from "../Spacer";
import AssetImgStyles from "./AssetImg.module.scss";

type AssetImgActive = {
	timer: string
}

export const AssetImgActive = ({ timer }: AssetImgActive) => {

	return (
		<div className={AssetImgStyles.imgActive}>
			<div>time to the next</div>
			<div>Enchant</div>
			<Spacer size={8} />
			<div className={AssetImgStyles.imgActiveText}>{timer}</div>
		</div>
	)
}
